const ScaRulesConditionFields = {
  AMOUNT: 'amount',
  CARD_COUNTRY: 'card_country',
  CUSTOMER_ID: 'customer_id',
  CUSTOMER_IP_COUNTRY: 'customer_ip_country',
  CUSTOMER_EMAIL: 'customer_email',
  ISSUER: 'issuer',
  PRODUCT_TYPE: 'product_type',
  SCHEME: 'scheme',
  STORE_ID: 'store_id',
};

module.exports = ScaRulesConditionFields;
